/*
  launch-collection.js
  Small behaviours for the launch collection sections. All handlers are
  delegated from document, so they keep working after the theme's AJAX filter
  refresh replaces the grid markup.
    1. Mobile filters toggle: [data-lcc-filter-trigger] opens the sibling
       [data-lcc-filter-panel] (same class the theme uses: filters-open).
    2. Quick add size select: [data-lcc-variant] updates the add button's
       data-variant-ids, label and disabled state. launch-cart.js does the add.
    3. Jump chips in the fragrance hero: each [data-lc-jump] shows the product
       count of its format group and hides when the group is not on the page.
    4. In-place tabs [data-lc-tab], scent family chips [data-lc-fam] and Load
       more [data-lc-more] over the cards already on the page ([data-lc-keys]).
    5. Fragrance cards [data-lc-pcard]: size and format buttons swap the image,
       price, size line and the add button's variant. launch-cart.js adds.
    6. Sort menu [data-lc-sort] over the cards on the page.
    7. Holiday rail [data-lc-rail]: fragrance tiles and format chips filter the
       format groups ([data-lc-fgkey]) in place.
*/
(function () {
  if (window.LaunchCollection) return;

  /* ---------- 1. mobile filters ---------- */
  function onClick(e) {
    var trigger = e.target.closest('[data-lcc-filter-trigger]');
    if (trigger) {
      e.preventDefault();
      var wrap = trigger.closest('.filters-container');
      var panel = wrap ? wrap.querySelector('[data-lcc-filter-panel]') : null;
      if (!panel) return;
      var open = !panel.classList.contains('filters-open');
      panel.classList.toggle('filters-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var openPanel = document.querySelector('.launch-cgrid [data-lcc-filter-panel].filters-open');
    if (openPanel && !e.target.closest('.filters-container')) {
      openPanel.classList.remove('filters-open');
      var t = openPanel.parentNode.querySelector('[data-lcc-filter-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  }

  function onKey(e) {
    if (e.key !== 'Escape') return;
    var openPanel = document.querySelector('.launch-cgrid [data-lcc-filter-panel].filters-open');
    if (!openPanel) return;
    openPanel.classList.remove('filters-open');
    var t = openPanel.parentNode.querySelector('[data-lcc-filter-trigger]');
    if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
  }

  /* ---------- 2. quick add size select ---------- */
  function onChange(e) {
    var select = e.target.closest('[data-lcc-variant]');
    if (!select) return;
    var card = select.closest('[data-lcc-card]');
    var btn = card ? card.querySelector('[data-launch-add]') : null;
    if (!btn) return;
    var opt = select.options[select.selectedIndex];
    var available = opt && opt.getAttribute('data-available') === 'true';
    btn.setAttribute('data-variant-ids', select.value);
    btn.disabled = !available;
    var label = btn.querySelector('[data-launch-add-label]');
    if (label) {
      label.textContent = available
        ? (btn.getAttribute('data-add-text') || 'Add to bag')
        : (btn.getAttribute('data-soldout-text') || 'Sold out');
    }
    var status = document.getElementById(btn.getAttribute('aria-describedby') || '');
    if (status) { status.textContent = ''; status.classList.remove('is-error'); }
  }

  /* ---------- 3. jump chips ---------- */
  function initJumps() {
    var chips = document.querySelectorAll('[data-lc-jump]');
    for (var i = 0; i < chips.length; i++) {
      var li = chips[i];
      var id = li.getAttribute('data-lc-jump');
      var g = null;
      var groups = document.querySelectorAll('[data-lc-group]');
      for (var x = 0; x < groups.length; x++) {
        if (groups[x].getAttribute('data-lc-group') === id) { g = groups[x]; break; }
      }
      if (!g) { li.hidden = true; continue; }
      li.hidden = false;
      var n = li.querySelector('[data-lc-jump-count]');
      if (n) n.textContent = g.getAttribute('data-lc-count') || '';
    }
    var lists = document.querySelectorAll('[data-lc-jumps]');
    for (var j = 0; j < lists.length; j++) {
      lists[j].hidden = !lists[j].querySelector('[data-lc-jump]:not([hidden])');
    }
  }

  /* ---------- 4. tabs, family chips, load more ---------- */
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function words(el, attr) {
    var raw = (el && el.getAttribute(attr)) || '';
    return raw.split('|').map(function (w) { return w.trim(); }).filter(Boolean);
  }
  function hits(keys, list) {
    if (!list.length) return true;
    for (var i = 0; i < list.length; i++) { if (keys.indexOf(list[i]) !== -1) return true; }
    return false;
  }
  function apply(root) {
    var filters = root.querySelector('[data-lc-filters]');
    var grid = root.querySelector('.launch-cgrid__grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('[data-lc-keys]');
    var tab = filters ? filters.querySelector('[data-lc-tab][aria-pressed="true"]') : null;
    var fam = filters ? filters.querySelector('[data-lc-fam][aria-pressed="true"]') : null;
    var tabW = words(tab, 'data-lc-tab');
    var famW = words(fam, 'data-lc-fam');
    var limit = parseInt(root.getAttribute('data-lc-more') || '0', 10);
    var expanded = root.hasAttribute('data-lc-expanded');
    var matched = 0;
    var shown = 0;
    for (var i = 0; i < cards.length; i++) {
      var keys = cards[i].getAttribute('data-lc-keys') || '';
      var ok = hits(keys, tabW) && hits(keys, famW);
      if (ok) matched++;
      var show = ok && (expanded || !limit || matched <= limit);
      cards[i].hidden = !show;
      if (show) shown++;
    }
    var famChips = filters ? filters.querySelectorAll('[data-lc-fam]') : [];
    for (var f = 0; f < famChips.length; f++) {
      var fw = words(famChips[f], 'data-lc-fam');
      var c = 0;
      for (var k = 0; k < cards.length; k++) {
        var kk = cards[k].getAttribute('data-lc-keys') || '';
        if (hits(kk, tabW) && hits(kk, fw)) c++;
      }
      var n = famChips[f].querySelector('[data-lc-n]');
      setText(n, String(c));
      famChips[f].hidden = c === 0 && famChips[f].getAttribute('aria-pressed') !== 'true';
    }
    grid.classList.toggle('is-filtered', !!(tabW.length || famW.length));
    var count = root.querySelector('[data-lc-count]');
    if (count && count.getAttribute('data-lc-count-label')) {
      var cl = (tabW.length && count.getAttribute('data-lc-count-label-tab')) || count.getAttribute('data-lc-count-label');
      setText(count, cl.replace('[count]', matched));
    }
    var empty = root.querySelector('[data-lc-empty]');
    if (empty) empty.hidden = !(cards.length && matched === 0);
    var more = root.querySelector('[data-lc-more-wrap]');
    if (more) {
      more.hidden = !(limit && !expanded && matched > limit);
      var st = more.querySelector('[data-lc-more-status]');
      setText(st, (st && st.getAttribute("data-label") || "").replace("[shown]", shown).replace("[total]", matched));
    }
  }

  function onFilterClick(e) {
    var btn = e.target.closest('[data-lc-tab], [data-lc-fam], [data-lc-clear], [data-lc-more-btn]');
    if (!btn || btn.tagName === 'A') return false;
    var root = btn.closest('[data-launch-cgrid]');
    if (!root) return false;
    e.preventDefault();
    if (btn.hasAttribute('data-lc-more-btn')) {
      root.setAttribute('data-lc-expanded', '');
    } else if (btn.hasAttribute('data-lc-clear')) {
      var all = root.querySelectorAll('[data-lc-tab], [data-lc-fam]');
      for (var i = 0; i < all.length; i++) {
        all[i].setAttribute('aria-pressed', (all[i].getAttribute('data-lc-tab') === '' || all[i].getAttribute('data-lc-fam') === '') ? 'true' : 'false');
      }
    } else {
      var attr = btn.hasAttribute('data-lc-tab') ? 'data-lc-tab' : 'data-lc-fam';
      var was = btn.getAttribute('aria-pressed') === 'true';
      var sibs = root.querySelectorAll('[' + attr + ']');
      for (var j = 0; j < sibs.length; j++) sibs[j].setAttribute('aria-pressed', 'false');
      if (attr === 'data-lc-tab' || !was) btn.setAttribute('aria-pressed', 'true');
      if (attr === 'data-lc-fam' && !root.querySelector('[data-lc-fam][aria-pressed="true"]')) {
        var famAll = root.querySelector('[data-lc-fam=""]');
        if (famAll) famAll.setAttribute('aria-pressed', 'true');
      }
      root.removeAttribute('data-lc-expanded');
    }
    apply(root);
    if (btn.hasAttribute('data-lc-tab') || btn.hasAttribute('data-lc-clear')) {
      var at = root.querySelector('[data-lc-tab][aria-pressed="true"]');
      pcardFollowTab(root, words(at, 'data-lc-tab'));
    }
    return true;
  }

  function initGrids() {
    var roots = document.querySelectorAll('[data-launch-cgrid]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (!root.querySelector('[data-lc-filters]') && !root.hasAttribute('data-lc-more')) continue;
      apply(root);
      if (root.__lcObs || !window.MutationObserver) continue;
      var box = root.querySelector('[data-ajax-container]');
      if (!box) continue;
      root.__lcObs = new MutationObserver((function (r) {
        var busy = false;
        return function () {
          if (busy) return;
          busy = true;
          requestAnimationFrame(function () { busy = false; apply(r); });
        };
      })(root));
      root.__lcObs.observe(box, { childList: true, subtree: true });
    }
  }


  /* ---------- 5. fragrance cards: size and format buttons ---------- */
  function pcardSelect(card, leaf) {
    if (!card || !leaf) return;
    var leaves = card.querySelectorAll('[data-lc-leaf]');
    for (var i = 0; i < leaves.length; i++) leaves[i].setAttribute('aria-pressed', leaves[i] === leaf ? 'true' : 'false');
    var k = leaf.getAttribute('data-lc-parent');
    var mains = card.querySelectorAll('[data-lc-main]');
    for (var m = 0; m < mains.length; m++) mains[m].setAttribute('aria-pressed', mains[m].getAttribute('data-lc-main') === k ? 'true' : 'false');
    var subs = card.querySelectorAll('[data-lc-sub]');
    for (var s = 0; s < subs.length; s++) subs[s].hidden = subs[s].hasAttribute('data-lc-single') || subs[s].getAttribute('data-lc-sub') !== k;
    var img = card.querySelector('[data-lc-img]');
    var src = leaf.getAttribute('data-img');
    if (img && src) {
      img.hidden = false;
      if (img.getAttribute('src') !== src) {
        img.removeAttribute('srcset');
        img.setAttribute('src', src);
        var set = leaf.getAttribute('data-srcset');
        if (set) img.setAttribute('srcset', set);
      }
    }
    var hv = card.querySelector('[data-lc-hv]');
    if (hv) {
      var h = leaf.getAttribute('data-hv');
      if (h) { hv.setAttribute('src', h); hv.hidden = false; } else { hv.hidden = true; }
    }
    var tag = card.querySelector('[data-lc-tag]');
    if (tag) { var tt = leaf.getAttribute('data-tag') || ''; setText(tag, tt); tag.hidden = !tt; }
    setText(card.querySelector('[data-lc-row]'), leaf.getAttribute('data-row') || '');
    var price = leaf.getAttribute('data-price') || '';
    setText(card.querySelector('[data-lc-price-out]'), price);
    var links = card.querySelectorAll('[data-lc-link]');
    var url = leaf.getAttribute('data-url');
    for (var l = 0; l < links.length; l++) if (url) links[l].setAttribute('href', url);
    card.setAttribute('data-lc-price', leaf.getAttribute('data-cents') || '0');
    var btn = card.querySelector('[data-launch-add]');
    if (btn) {
      var ok = leaf.getAttribute('data-avail') === 'true';
      btn.setAttribute('data-variant-ids', leaf.getAttribute('data-v') || '');
      btn.disabled = !ok;
      var label = btn.querySelector('[data-launch-add-label]');
      setText(label, ok ? (card.getAttribute('data-add-tpl') || 'Add to cart · [price]').replace('[price]', price) : (card.getAttribute('data-soldout') || 'Sold out'));
    }
  }
  function pcardPickIn(card, k) {
    var ls = card.querySelectorAll('[data-lc-leaf][data-lc-parent="' + k + '"]');
    var pick = null;
    for (var i = 0; i < ls.length; i++) if (ls[i].getAttribute('aria-pressed') === 'true') pick = ls[i];
    if (!pick) for (var j = 0; j < ls.length; j++) if (ls[j].getAttribute('data-avail') === 'true') { pick = ls[j]; break; }
    return pick || ls[0] || null;
  }
  function onPcardClick(e) {
    var b = e.target.closest('[data-lc-main], [data-lc-leaf]');
    if (!b) return false;
    var card = b.closest('[data-lc-pcard]');
    if (!card) return false;
    e.preventDefault();
    pcardSelect(card, b.hasAttribute('data-lc-leaf') ? b : pcardPickIn(card, b.getAttribute('data-lc-main')));
    return true;
  }
  /* a tab such as "Classic 10.5 oz" also selects that size on every card */
  function pcardFollowTab(root, words) {
    var cards = root.querySelectorAll('[data-lc-pcard]');
    for (var i = 0; i < cards.length; i++) {
      var ls = cards[i].querySelectorAll('[data-lc-leaf]');
      var pick = null;
      if (words.length) {
        for (var j = 0; j < ls.length; j++) if (hits(ls[j].getAttribute('data-okeys') || '', words) && (!pick || (pick.getAttribute('data-avail') !== 'true' && ls[j].getAttribute('data-avail') === 'true'))) pick = ls[j];
      } else {
        var d = cards[i].getAttribute('data-lc-default');
        for (var x = 0; x < ls.length; x++) if (ls[x].getAttribute('data-v') === d) { pick = ls[x]; break; }
      }
      if (pick) pcardSelect(cards[i], pick);
    }
  }
  /* "Added to cart" for 1.6s after launch-cart.js finishes */
  var lastAdd = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lc-pcard] [data-launch-add], [data-lc-feature] [data-launch-add]');
    if (b) lastAdd = b;
  }, true);
  document.addEventListener('launch:cart:changed', function () {
    var b = lastAdd; lastAdd = null;
    if (!b) return;
    setTimeout(function () {
      var label = b.querySelector('[data-launch-add-label]');
      if (!label) return;
      var was = label.textContent;
      label.textContent = b.getAttribute('data-added-text') || 'Added to cart';
      setTimeout(function () { if (label.textContent === (b.getAttribute('data-added-text') || 'Added to cart')) label.textContent = was; }, 1600);
    }, 0);
  });

  /* ---------- 6. sort menu over the cards on the page ---------- */
  function onSort(e) {
    var sel = e.target.closest('[data-lc-sort]');
    if (!sel) return false;
    var root = sel.closest('[data-launch-cgrid]');
    var grid = root && root.querySelector('.launch-cgrid__grid');
    if (!grid) return true;
    var kids = Array.prototype.slice.call(grid.children);
    kids.forEach(function (el, i) { if (!el.hasAttribute('data-lc-dom')) el.setAttribute('data-lc-dom', String(i)); });
    var v = sel.value;
    var num = function (el, a) { return parseFloat(el.getAttribute(a) || '0'); };
    var dom = function (a, b) { return num(a, 'data-lc-dom') - num(b, 'data-lc-dom'); };
    var cards = kids.filter(function (el) { return el.hasAttribute('data-lc-keys'); });
    var other = kids.filter(function (el) { return !el.hasAttribute('data-lc-keys'); });
    if (v === 'pos') {
      kids.sort(dom).forEach(function (el) { grid.appendChild(el); });
    } else {
      cards.sort(function (a, b) {
        if (v === 'price-asc') return num(a, 'data-lc-price') - num(b, 'data-lc-price') || dom(a, b);
        if (v === 'price-desc') return num(b, 'data-lc-price') - num(a, 'data-lc-price') || dom(a, b);
        if (v === 'date') return num(b, 'data-lc-date') - num(a, 'data-lc-date') || dom(a, b);
        return (a.getAttribute('data-lc-name') || '').localeCompare(b.getAttribute('data-lc-name') || '');
      });
      cards.concat(other).forEach(function (el) { grid.appendChild(el); });
    }
    grid.classList.toggle('is-sorted', v !== 'pos');
    root.removeAttribute('data-lc-expanded');
    apply(root);
    return true;
  }

  /* ---------- 7. holiday rail: fragrance tiles and format chips over the format groups ---------- */
  function railApply(rail) {
    var fragBtn = rail.querySelector('[data-lc-frag][aria-pressed="true"]');
    var fmtBtn = rail.querySelector('[data-lc-fmt][aria-pressed="true"]');
    var frag = fragBtn ? fragBtn.getAttribute('data-lc-frag') : '';
    var fmtW = words(fmtBtn, 'data-lc-fmt');
    var groups = (rail.closest('main') || document).querySelectorAll('[data-lc-fgkey]');
    var total = 0, nGroups = 0;
    for (var g = 0; g < groups.length; g++) {
      var on = !frag || groups[g].getAttribute('data-lc-fgkey') === frag;
      var items = groups[g].querySelectorAll('[data-lc-keys]');
      var n = 0;
      for (var i = 0; i < items.length; i++) {
        var ok = on && hits(items[i].getAttribute('data-lc-keys') || '', fmtW);
        items[i].hidden = !ok;
        if (ok) n++;
      }
      groups[g].hidden = n === 0;
      total += n;
      if (n) nGroups++;
    }
    var c = rail.querySelector('[data-lc-hcount]');
    if (c) {
      var lab = frag ? (c.getAttribute('data-label-one') || '[count] products in [name]') : (c.getAttribute('data-label') || '[count] products across [groups] fragrances');
      setText(c, lab.replace('[count]', total).replace('[groups]', nGroups).replace('[name]', fragBtn ? (fragBtn.getAttribute('data-name') || '') : ''));
    }
  }
  function onRailClick(e) {
    var b = e.target.closest('[data-lc-frag], [data-lc-fmt]');
    if (!b || b.tagName === 'A') return false;
    var rail = b.closest('[data-lc-rail]');
    if (!rail) return false;
    e.preventDefault();
    var attr = b.hasAttribute('data-lc-frag') ? 'data-lc-frag' : 'data-lc-fmt';
    var was = b.getAttribute('aria-pressed') === 'true';
    var sibs = rail.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < sibs.length; i++) sibs[i].setAttribute('aria-pressed', 'false');
    if (attr === 'data-lc-fmt' || !was) b.setAttribute('aria-pressed', 'true');
    railApply(rail);
    return true;
  }
  function initRails() {
    var rails = document.querySelectorAll('[data-lc-rail]');
    for (var i = 0; i < rails.length; i++) railApply(rails[i]);
  }

  function init() { initJumps(); initGrids(); initRails(); }

  document.addEventListener('click', function (e) { if (onPcardClick(e) || onRailClick(e)) return; if (!onFilterClick(e)) onClick(e); });
  document.addEventListener('keydown', onKey);
  document.addEventListener('change', function (e) { if (!onSort(e)) onChange(e); });
  document.addEventListener('shopify:section:load', init);
  /* theme editor: stop watching a grid once its section is removed or re-rendered */
  document.addEventListener('shopify:section:unload', function (e) {
    var roots = e.target.querySelectorAll('[data-launch-cgrid]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__lcObs) { roots[i].__lcObs.disconnect(); roots[i].__lcObs = null; }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.LaunchCollection = { version: 3, refresh: init, select: pcardSelect };
})();
